import * as types from './types';

/* const type = {
  GET: types.GET_DATA_MICROSITE,
  PUT: types.PUT_DATA_MICROSITE,
  POST: types.POST_DATA_MICROSITE,
  DELETE: types.DELETE_IMAGE_COVER_PHOTO
}; */

const apiRequest = ({ method = 'GET', typeMethod = '', path = '', body = {}, queryParams = {} }) => ({
  type: typeMethod,
  meta: {
    async: true,
    api: 'pubr',
    path: `/api/v1/landing/config/publisher/${path}`,
    body,
    query: queryParams,
    method,
    section: path
  }
});

export { apiRequest };
